import React from "react";
var __jsx = React.createElement;
import Image from "../UI/Image";
import { useGlobal } from "../../utils/useGlobal";
import css from "./index.module.scss";
export default function producntBanner() {
  var _useGlobal = useGlobal(),
    useLang = _useGlobal.useLang,
    isMobile = _useGlobal.isMobile;
  var _useLang = useLang('shared'),
    t = _useLang.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
    className: "".concat(css.banner, " pro-banner")
  }, /*#__PURE__*/React.createElement("span", {
    className: "imgs"
  }, /*#__PURE__*/React.createElement(Image, {
    src: isMobile ? '/img/compare/compareBannerh5.jpg' : '/img/compare/compareBanner.jpg',
    layout: "fill",
    className: "fullImgs",
    alt: t('collections.site_product_comparison_title')
  }))));
}
producntBanner.displayName = "producntBanner";